import * as tslib_1 from "tslib";
import { AfterContentInit, ViewContainerRef } from '@angular/core';
import { ESRI } from '../../../esri-loader-util';
import { InputConverter } from '../../../inputConverter';
import { LayerService } from '../../../services/layer.service';
import { BaseComponent } from '../../base.component';
var PennbotsConnectorComponent = /** @class */ (function (_super) {
    tslib_1.__extends(PennbotsConnectorComponent, _super);
    function PennbotsConnectorComponent(_vcr, layerService) {
        var _this = _super.call(this, _vcr, false) || this;
        _this.layerService = layerService;
        _this.streetviewInitialized = false;
        _this.videologInitialized = false;
        _this.scopeDictionary = {};
        _this.angle = 0;
        _this.arrowColorR = 40;
        _this.arrowColorG = 96;
        _this.arrowColorB = 144;
        _this.arrowPath = 'M192 320L0 576h128v128h128V576h128L192 320z';
        _this.arrowSize = '16px';
        _this.videologColor = [0, 0, 0];
        _this.videologTolerance = 400;
        _this.petlLayerId = 2701;
        _this.streetviewScopeId = 0;
        _this.videologScopeId = 0;
        _this._streetviewEnabled = false;
        _this._videologEnabled = false;
        _this.initialize();
        return _this;
    }
    Object.defineProperty(PennbotsConnectorComponent.prototype, "streetviewEnabled", {
        get: function () { return this._streetviewEnabled; },
        set: function (value) {
            this._streetviewEnabled = value;
            var $scope = this.getAngularScope('streetview');
            if ($scope) {
                $scope.streetviewActive = value;
            }
            if (value) {
                if (!this.streetviewInitialized) {
                    this.setupStreetviewWatch();
                    this.initializeStreetViewMarker();
                    this.streetviewInitialized = true;
                }
                this.setStreetviewPosition(true);
            }
            else {
                if (this.arrowGraphic) {
                    this.mapViewRef.graphics.remove(this.arrowGraphic);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PennbotsConnectorComponent.prototype, "videologEnabled", {
        get: function () { return this._videologEnabled; },
        set: function (value) {
            this._videologEnabled = value;
            var $scope = this.getAngularScope('videolog');
            if ($scope) {
                $scope.videologActive = value;
            }
            var videologScope = this.getScopeById(this.videologScopeId);
            if (videologScope) {
                videologScope.vm.options.crsTolerance = this.videologTolerance;
                if (value) {
                    if (!this.videologInitialized) {
                        this.setupVideologWatch();
                        this.initializeVideologMarker();
                        this.videologInitialized = true;
                    }
                    this.setVideologPosition(true);
                }
                else {
                    videologScope.$$childHead.vm.startOrStopVideo(false);
                    if (this.videologGraphic) {
                        this.mapViewRef.graphics.remove(this.videologGraphic);
                    }
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    PennbotsConnectorComponent.prototype.initialize = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!window.jQuery) {
                            window.$ = function () { return { draggable: function () { return false; } }; };
                        }
                        else if (!window.jQuery.ui) {
                            window.jQuery.fn.extend({ draggable: function () { return false; } });
                        }
                        return [4 /*yield*/, this.loadEsriModules()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.setMapViewRef()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.initializeMapViewClickHandler()];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PennbotsConnectorComponent.prototype.initializeMapViewClickHandler = function () {
        var _this = this;
        this.mapViewRef.on('click', function (event) {
            if (_this.streetviewEnabled || _this.videologEnabled) {
                var geographicPoint = _this.webMercatorUtils.webMercatorToGeographic(event.mapPoint);
                var precision = 5;
                _this.lat = parseFloat(geographicPoint.y.toFixed(precision));
                _this.long = parseFloat(geographicPoint.x.toFixed(precision));
            }
            if (_this.streetviewEnabled) {
                _this.setStreetviewPosition();
            }
            if (_this.videologEnabled) {
                _this.setVideologPosition();
            }
        });
    };
    PennbotsConnectorComponent.prototype.initializeStreetViewMarker = function () {
        var streetViewArrowColor = [this.arrowColorR, this.arrowColorG, this.arrowColorB];
        var symbolType = 'simple-marker';
        this.arrowSymbol = {
            type: symbolType,
            color: streetViewArrowColor,
            size: this.arrowSize,
            path: this.arrowPath,
            angle: 0,
            outline: {
                color: streetViewArrowColor,
                width: 1
            }
        };
    };
    PennbotsConnectorComponent.prototype.initializeVideologMarker = function () {
        var symbolType = 'simple-marker';
        this.videologSymbol = {
            type: symbolType,
            color: this.videologColor,
            size: 10,
            angle: 0,
            outline: {
                color: this.videologColor,
                width: 1
            }
        };
    };
    PennbotsConnectorComponent.prototype.setMapViewRef = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var parent_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.mapViewRef) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.getClosestAncestor('mc-map')];
                    case 1:
                        parent_1 = _a.sent();
                        if (!parent_1) return [3 /*break*/, 3];
                        return [4 /*yield*/, parent_1.ready];
                    case 2:
                        _a.sent();
                        this.mapViewRef = parent_1.mapView;
                        return [3 /*break*/, 4];
                    case 3:
                        this.readyProblem('Map View Reference not supplied and reference from parent element could not be retrieved.');
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    PennbotsConnectorComponent.prototype.loadEsriModules = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, ESRI.WebMercatorUtils];
                    case 1:
                        _a.webMercatorUtils = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PennbotsConnectorComponent.prototype.ngAfterContentInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var angular;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                angular = window.angular;
                angular.module('PennBOTSApp', ['bots', 'petl']).config(['$compileProvider', function ($compileProvider) {
                        $compileProvider.preAssignBindingsEnabled(true);
                    }]);
                angular.module('PennBOTSApp').controller('pennbots.main', ['$rootScope', 'petlService',
                    function ($rootScope, petlService) { _this.mainController($rootScope, petlService); }]);
                return [2 /*return*/];
            });
        });
    };
    PennbotsConnectorComponent.prototype.mainController = function ($rootScope, petlService) {
        var _this = this;
        $rootScope.$on(petlService.mapProjectBroadcastName, function () {
            _this.addPETLProjectToMap(petlService.project.id);
        });
    };
    PennbotsConnectorComponent.prototype.setStreetviewPosition = function (apply) {
        if (apply === void 0) { apply = false; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var scope;
            return tslib_1.__generator(this, function (_a) {
                if (this.lat && this.long) {
                    scope = this.getScopeById(this.streetviewScopeId);
                    scope.isActive = true;
                    scope.lat = this.lat;
                    scope.long = this.long;
                    scope.heading = this.angle;
                    scope.vm.zoom = this.mapViewRef.zoom;
                    if (apply) {
                        scope.$apply();
                    }
                    this.setStreetviewGraphicPosition();
                }
                return [2 /*return*/];
            });
        });
    };
    PennbotsConnectorComponent.prototype.setVideologPosition = function (apply) {
        if (apply === void 0) { apply = false; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var scope;
            return tslib_1.__generator(this, function (_a) {
                if (this.lat && this.long) {
                    scope = this.getScopeById(this.videologScopeId);
                    scope.vm.isActive = true;
                    scope.vm.lat = this.lat;
                    scope.vm.long = this.long;
                    if (apply) {
                        scope.$apply();
                    }
                    this.setVideologGraphicPosition();
                }
                return [2 /*return*/];
            });
        });
    };
    PennbotsConnectorComponent.prototype.setupStreetviewWatch = function () {
        var _this = this;
        var $scope = this.getAngularScope('streetview');
        var streetviewScope = this.getScopeById(this.streetviewScopeId);
        $scope.$watchGroup([function () { return streetviewScope.lat; }, function () { return streetviewScope.long; }, function () { return streetviewScope.heading; }], function () {
            if (streetviewScope && streetviewScope.long) {
                _this.long = streetviewScope.long;
                _this.lat = streetviewScope.lat;
                _this.angle = streetviewScope.heading;
            }
            if (streetviewScope && _this.streetviewEnabled) {
                _this.setStreetviewPosition();
            }
        });
    };
    PennbotsConnectorComponent.prototype.setupVideologWatch = function () {
        var _this = this;
        var $scope = this.getAngularScope('videolog');
        var videologScope = this.getScopeById(this.videologScopeId);
        $scope.$watchGroup([function () { return videologScope.vm.lat; }, function () { return videologScope.vm.long; }], function () {
            if (videologScope && videologScope.vm.long) {
                _this.long = videologScope.vm.long;
                _this.lat = videologScope.vm.lat;
            }
            if (videologScope && _this.videologEnabled) {
                _this.setVideologPosition();
            }
        });
    };
    PennbotsConnectorComponent.prototype.getAngularScope = function (elementId) {
        var streetview = document.getElementById(elementId);
        var angular = window.angular;
        return angular.element(streetview).scope();
    };
    PennbotsConnectorComponent.prototype.getScopeById = function (id) {
        if (this.scopeDictionary[id]) {
            return this.scopeDictionary[id];
        }
        else {
            var scope = this.findScopeByid(id);
            if (scope) {
                this.scopeDictionary[id] = scope;
            }
            return scope;
        }
    };
    PennbotsConnectorComponent.prototype.findScopeByid = function (id) {
        var angular = window.angular;
        var ngScopeArray = [].slice.call(document.querySelectorAll('.ng-scope'));
        var elementArrray = ngScopeArray.map(function (x) { return angular.element(x); });
        var scopeArray = elementArrray.map(function (x) { return x.scope(); });
        var scopesFound = scopeArray.filter(function (y) { return y.$id === id; });
        if (scopesFound.length > 0) {
            return scopesFound[0];
        }
        else {
            var childHeads = scopeArray.filter(function (x) { return x.$$childHead; }).map(function (y) { return y.$$childHead; });
            var childHeadsFound = childHeads.filter(function (x) { return x.$id === id; });
            if (childHeadsFound.length > 0) {
                return childHeadsFound[0];
            }
            else {
                var childSiblings = childHeads.filter(function (x) { return x.$$nextSibling; }).map(function (y) { return y.$$nextSibling; });
                var childSiblingsFound = childSiblings.filter(function (x) { return x.$id === id; });
                if (childSiblingsFound.length > 0) {
                    return childSiblingsFound[0];
                }
            }
        }
        return null;
    };
    PennbotsConnectorComponent.prototype.setStreetviewGraphicPosition = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, Graphic, Point, geographicPoint;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ESRI.loadModules('esri/Graphic', 'esri/geometry/Point')];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 2]), Graphic = _a[0], Point = _a[1];
                        geographicPoint = new Point({ x: this.long, y: this.lat });
                        if (this.angle || this.angle === 0) {
                            this.arrowSymbol.angle = this.angle;
                        }
                        if (this.arrowGraphic) {
                            this.mapViewRef.graphics.remove(this.arrowGraphic);
                        }
                        this.arrowGraphic = new Graphic({
                            geometry: geographicPoint,
                            symbol: this.arrowSymbol
                        });
                        this.mapViewRef.graphics.add(this.arrowGraphic);
                        return [2 /*return*/];
                }
            });
        });
    };
    PennbotsConnectorComponent.prototype.setVideologGraphicPosition = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, Graphic, Point, geographicPoint;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ESRI.loadModules('esri/Graphic', 'esri/geometry/Point')];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 2]), Graphic = _a[0], Point = _a[1];
                        geographicPoint = new Point({ x: this.long, y: this.lat });
                        if (this.videologGraphic) {
                            this.mapViewRef.graphics.remove(this.videologGraphic);
                        }
                        this.videologGraphic = new Graphic({
                            geometry: geographicPoint,
                            symbol: this.videologSymbol
                        });
                        this.mapViewRef.graphics.add(this.videologGraphic);
                        return [2 /*return*/];
                }
            });
        });
    };
    PennbotsConnectorComponent.prototype.addPETLProjectToMap = function (projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var query, layerSettings;
            return tslib_1.__generator(this, function (_a) {
                query = { field: 'project_no', operator: '=', value: projectId.toString() };
                query.operator = '=';
                layerSettings = { id: this.petlLayerId, query: query, zoomToLayer: true };
                this.layerService.addMapcoreLayersToMap([layerSettings]);
                return [2 /*return*/];
            });
        });
    };
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Number)
    ], PennbotsConnectorComponent.prototype, "lat", void 0);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Number)
    ], PennbotsConnectorComponent.prototype, "long", void 0);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Number)
    ], PennbotsConnectorComponent.prototype, "videologTolerance", void 0);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Number)
    ], PennbotsConnectorComponent.prototype, "streetviewScopeId", void 0);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Number)
    ], PennbotsConnectorComponent.prototype, "videologScopeId", void 0);
    return PennbotsConnectorComponent;
}(BaseComponent));
export { PennbotsConnectorComponent };
